import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles/index';
import {
    AppBar,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core';
import classNames from 'classnames';
import {FuseAnimateGroup} from '@fuse';
import {withRouter} from "react-router-dom";

const styles = theme => ({
    root: {}
});

class AboutTab extends Component {

    state = {
        general: null,
        work: null,
    };

    componentDidMount() {

        const {user} = this.props;
        const medical = user.medical;

        const general = user;

        const work = (medical) ? {
            "occupation": "Developer",
            city: medical.city,
            hospital: medical.hospital,
            unvalidated_hospital_name: medical.unvalidated_hospital_name,
            certificate_no: medical.certificate_no,
        } : null;

        this.setState({general, work});
    }

    render() {
        const {classes} = this.props;
        const {general, work} = this.state;

        return (
            <div className={classNames(classes.root, "md:flex max-w-2xl")}>

                <div className="flex flex-col flex-1 md:pr-32">
                    <FuseAnimateGroup
                        enter={{
                            animation: "transition.slideUpBigIn"
                        }}
                    >
                        {general && (
                            <Card className="w-full mb-16">
                                <AppBar position="static" elevation={0}>
                                    <Toolbar className="pl-16 pr-8">
                                        <Typography variant="subheading" color="inherit" className="flex-1">
                                            個人資料
                                        </Typography>
                                    </Toolbar>
                                </AppBar>

                                <CardContent>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">信箱</Typography>
                                        <Typography>{general.email}</Typography>
                                    </div>

                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">性別</Typography>
                                        <Typography>{general.sex}</Typography>
                                    </div>

                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">生日</Typography>
                                        <Typography>{general.birthday}</Typography>
                                    </div>

                                </CardContent>
                            </Card>
                        )}

                        {work && (
                            <Card className="w-full mb-16">
                                <AppBar position="static" elevation={0}>
                                    <Toolbar className="pl-16 pr-8">
                                        <Typography variant="subheading" color="inherit" className="flex-1">
                                            服務設定
                                        </Typography>
                                    </Toolbar>
                                </AppBar>

                                <CardContent>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">服務醫療機構</Typography>
                                        <Typography>{(work.hospital) ? work.hospital.name : work.unvalidated_hospital_name}</Typography>
                                    </div>

                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">執業縣市</Typography>
                                        <Typography>{(work.city) ? work.city.name : ''}</Typography>
                                    </div>

                                </CardContent>
                            </Card>
                        )}

                    </FuseAnimateGroup>
                </div>

            </div>
        );
    }
}

function mapStateToProps({auth}) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, null)(AboutTab)));



// WEBPACK FOOTER //
// ./src/main/content/profile/tabs/AboutTab.js